export function nameCompiler(user:any) {
  if (!user) return null;

  const fullName = [user.lastname, user.firstname, user.middlename]
    .filter((el) => el?.trim().length) // .trim() захистить від випадкових пробілів у базі
    .join(" ");

  return fullName.length > 0 ? fullName : null;
}

export function nameLastCompiler(user: any) {
  return user
    ? [user.lastname, user.firstname]
        .filter((el) => el?.length)
        .join(" ")
    : null;
}
